import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { BehaviorSubject, Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class MainService {
  //baseURL: String = "http://localhost:8080/api/";
  //baseURLUP: String = "localhost:8080/";
  baseURL: String = environment.apiBaseUrl;
  headers: Headers;
  private filtroGEP: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  public filtroGEP$: Observable<any[]> = this.filtroGEP.asObservable();
  
  constructor(
      private http: Http,
  ) {
    this.headers = new Headers();
    this.headers.append('Content-Type', 'application/json');
  }
  get(object: String) {
    return this.http.get(this.baseURL + '' + object, { headers: this.headers })
        .pipe(map(res => res.json()));
  }
  getFilterGep() {
    return this.filtroGEP$
  }
  getData() {
    const headers = new Headers();
    headers.append('Access-Control-Allow-Headers', 'Content-Type');
    headers.append('Access-Control-Allow-Methods', 'GET');
    headers.append('Access-Control-Allow-Origin', '*');
    return this.http.get(`${environment.geoserverBaseUrl}/bioap/wms?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetFeatureInfo&FORMAT=image%2Fpng&TRANSPARENT=true&QUERY_LAYERS=bioap%3Adom_cober_tierra%2Cbioap%3Adom_flora&LAYERS=bioap%3Adom_cober_tierra%2Cbioap%3Adom_flora&TILED=true&INFO_FORMAT=text%2Fhtml&I=230&J=18&WIDTH=256&HEIGHT=256&CRS=EPSG%3A3857&STYLES=&BBOX=-8140237.7642581295%2C479413.04140462726%2C-8130453.824637627%2C489196.98102512985`, { headers: this.headers })
        .pipe(map(res => res.json()));
  }
  mapa(object: String) {
    return this.http.get(this.baseURL + '' + object, { headers: this.headers })
        .pipe(map(res => res.json()));
  }
  delete(object: String) {
    return this.http.delete(this.baseURL + '' + object, { headers: this.headers })
        .map(res => res.json());
  }
  post(object: String, data: any) {
    return this.http.post(this.baseURL + '' + object, JSON.stringify(data), { headers: this.headers })
        .pipe(
            map(res => res.json())
        );
  }
  put(object: String, data: any) {
    return this.http.put(this.baseURL + '' + object, JSON.stringify(data), { headers: this.headers })
        .pipe(
            map(res => res.json())
        );
  }
  getEmpresas()
  {
    return  this.http.get(this.baseURL+'tadmEmpresa/', {headers: this.headers}).pipe(map( res => res.json()));   
  }

  getFiltroGEPGeom(){
    
  }

  updateFiltro(updatedList) {
    this.filtroGEP.next(updatedList);
  }
}